document.addEventListener('DOMContentLoaded', function () {
    // FILTER ARTICLES
    document.querySelectorAll('.filter-buttons button').forEach((button) => {
        button.addEventListener('click', function () {
            document.querySelectorAll('.filter-buttons button').forEach((btn) => btn.classList.remove('active'));
            this.classList.add('active');

            let filter = this.getAttribute('data-filter');
            //count filtered articles
            let count = 0;
            document.querySelectorAll('.blog-post').forEach((post) => {
                if (filter === 'all' || post.dataset.category.includes(filter)) {
                    count++;
                }
            });
            // Update the count display
            document.getElementById('filtered-article-count').textContent= `${count}`;
            document.querySelectorAll('.blog-post').forEach((post) => {
                post.style.display = filter === 'all' || post.dataset.category.includes(filter) ? 'block' : 'none';
            });

            // Reapply sorting after filtering
            sortArticles(document.querySelector('.sortblogs').value);
        });
    });

    // Add event listener to the sort dropdown
    document.querySelectorAll('.sortblogs').forEach((dropdown) => {
        dropdown.addEventListener('change', function () {
            sortArticles(this.value);
        });
    });

    function sortArticles(sortBy) {
        let container = document.querySelector('.blog-list');
        let posts = Array.from(container.children);

        posts.sort((a, b) => {
            let dateA = new Date(a.dataset.date);
            let dateB = new Date(b.dataset.date);
            return sortBy === 'date-desc' ? dateB - dateA : dateA - dateB;
        });

        posts.forEach((post) => container.appendChild(post)); // Reorder elements in the DOM
    }

    // ✅ Set default sort on page load
    let defaultSort = document.querySelector('.sortblogs');
    if (defaultSort) {
        defaultSort.value = 'date-desc'; // Set the value
        defaultSort.dispatchEvent(new Event('change', { bubbles: true })); // Trigger change event
    }
});
